module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/highFaceIcon.c080f1b3.svg";